import React, { Component } from "react"
import LoginLink from "../common/loginLink"
import * as endpoint from "../../constants/Endpoints"

import config from "react-global-configuration"
import * as countryHelper from "../../helpers/countryHelper"
import * as trackingHelper from "../../helpers/tracking"
import { emailValidatingRegex, specialCharsRegex } from "../BookingJourney"

class CheckoutBillingInformation extends Component {
  state = {
    emptyBillingAddress: {},
    emailPopupShown: false,
  }
  componentDidMount() {
    const { billingAddress } = this.props

    const emptyBillingAddress = { ...billingAddress }
    for (var key in emptyBillingAddress) {
      if (emptyBillingAddress[key] && emptyBillingAddress[key]?.length > 0) {
        delete emptyBillingAddress[key]
      } else {
        emptyBillingAddress[key] = ""
      }
    }
    if (emptyBillingAddress.countryId) {
      emptyBillingAddress.country = countryHelper.getCountryName(emptyBillingAddress.countryId)
    }
    this.setState({ emptyBillingAddress })
  }

  handleInputChange(event, maxLength, disablePostcodeFunction = false) {
    const { target } = event
    const value = target.value.slice(0, maxLength)
    const name = target.name
    let newBillingAddress = this.props.billingAddress
    newBillingAddress[name] = value
    this.props.updateCheckoutState("billingAddress", newBillingAddress, this.props.getRequiredFields())
    if (name === "postcode" && !disablePostcodeFunction) {
      this.handlePostcodeInput(value)
    }
  }

  handlePhoneRegex(event) {
    const phoneRegex = /^([+\d]*)$/

    //Allow deletion of the first '+' sign in the input field.
    if (!event.target.value) {
      this.handleInputChange(event, 20)
      return
    }
    //evaluate if phone number contains'+' and digits.
    if (phoneRegex.test(event.target.value)) {
      if (event.target.value) this.handleInputChange(event, 20)
    }
  }

  handlePostcodeInput(postcode) {
    let city
    let el = document.getElementById("town")
    let newBillingAddress = this.props.billingAddress
    if (postcode?.length === 4) {
      let apiurl = "https://dawa.aws.dk/postnumre/autocomplete?q={" + postcode + "}"
      fetch(apiurl)
        .then((response) => {
          return response.json()
        })
        .then((data) => {
          city = data[0].postnummer.navn
          el.value = city
          newBillingAddress[el.name] = el.value
          this.props.updateCheckoutState("billingAddress", newBillingAddress, this.props.getRequiredFields())
        })
        .catch((e) => {
          console.log(e.message)
        })
    } else if (postcode?.length < 4) {
      el.value = ""
      newBillingAddress[el.name] = el.value
      this.props.updateCheckoutState("billingAddress", newBillingAddress, this.props.getRequiredFields())
    }
  }

  handleCountryChange(event) {
    const { target } = event
    const value = target.value
    const name = target.name
    let newBillingAddress = this.props.billingAddress
    newBillingAddress[name] = value
    newBillingAddress["country"] = countryHelper.getCountryName(value)
    this.props.updateCheckoutState("billingAddress", newBillingAddress, this.props.getRequiredFields())
  }

  renderAdvantageLogin() {
    const { userAccountDetails } = this.props
    const textKeys = config.get("textKeys.checkout.billing") || {}
    const headerMenuTextKeys = config.get("textKeys.headerMenu") || {}

    return userAccountDetails ? (
      <div className="info-banner has-icon info-banner--inverted info-banner--flex">
        {/* <span className="icon">
                        <svg className="svg-icon svg-icon--advantagecardold">
                            <use xmlnsXlink="http://www.w3.org/1999/xlink" xlinkHref="/dist/svg/symbols.svg#svg-advantagecardold">&nbsp;</use>
                        </svg>
                    </span> */}
        <p>{textKeys.advantageReward || `Vi har forudfyldt felterne nedenfor med data fra din profil, du kan rette data på din profilside`}</p>
      </div>
    ) : (
      <div className="info-banner info-banner--inverted info-banner--flex">
        <span className="icon">
          <svg className="svg-icon svg-icon--user">
            <use xmlnsXlink="http://www.w3.org/1999/xlink" xlinkHref="/dist/svg/symbols.svg#svg-user">
              &nbsp;
            </use>
          </svg>
        </span>
        {/* <span className="icon">
                        <svg className="svg-icon svg-icon--advantagecardold">
                            <use xmlnsXlink="http://www.w3.org/1999/xlink" xlinkHref="/dist/svg/symbols.svg#svg-advantagecardold">&nbsp;</use>
                        </svg>
                    </span> */}
        <p>
          {textKeys.advantageEarn || "Log ind og slip for at udfylde dine oplysninger. "}
          &nbsp;
          <LoginLink
            {...this.props}
            loginurl={endpoint.ACCOUNT_LOGIN()}
            linkText={headerMenuTextKeys.login || "Log ind"}
            trackingHandler={() => trackingHelper.trackCTALoginButtonClick("parking - payment info")}
          />
        </p>
      </div>
    )
  }

  //this needs to be re-made so it checks on login session and not if the product you have chosen is a budget or featured product.
  // showAdvantageLogin() {
  //     const { userAccountDetails } = this.props;
  //     if (userAccountDetails) {
  //         return false
  //     }
  //     return true
  // }
  render() {
    const { modificationSummary } = this.props.bookingResult
    const { emptyBillingAddress } = this.state
    const isUpgrade = !!modificationSummary
    // if (isUpgrade) return null

    const { billingAddress, checkoutErrors } = this.props

    // const registrationNumberError = isVehicleRegistrationNumberRequired && checkoutErrors.vehicleRegistrationNumber
    // const vehicleMakeError = isVehicleMakeRequired && checkoutErrors.vehicleMake
    // const vehicleModelError = isVehicleModelRequired && checkoutErrors.vehicleModel
    // const vehicleColourError = isVehicleColourRequired && checkoutErrors.vehicleColour

    // const anyBillingError = checkoutErrors.firstName || checkoutErrors.lastName || checkoutErrors.postcode || checkoutErrors.town || checkoutErrors.email || checkoutErrors.mobilePhone

    const billingErrorArray = [
      checkoutErrors.firstName,
      checkoutErrors.lastName,
      checkoutErrors.postcode,
      checkoutErrors.town,
      checkoutErrors.email,
      checkoutErrors.mobilePhone,
      checkoutErrors.mobilePhoneFormat,
    ]
    var count = 0
    billingErrorArray.forEach((e) => (e ? count++ : null))
    const moreThanOneBillingError = count > 1

    if (isUpgrade && Object.keys(emptyBillingAddress)?.length === 0) return null
    const textKeys = config.get("textKeys.checkout.billing") || {}
    const hideFields = config.get("textKeys.checkout.hideBillingFields") || {}
    const validationTextKeys = config.get("textKeys.checkout.billingValidationMessages") || {}

    const emailHasContent = billingAddress.email && billingAddress.email?.length > 0
    const isEmailError =
      ((checkoutErrors.email || checkoutErrors.specialCharsEmail || checkoutErrors.cphEmail) && checkoutErrors.showErrors) ||
      (emailHasContent && !emailValidatingRegex.test(billingAddress.email) && !specialCharsRegex.test(billingAddress.email))
    const isEmailAppleRelay = billingAddress.email.includes("privaterelay.appleid.com")
    // const isCphEmail = cphEmailRegex.test(billingAddress.email)
    // console.log(isCphEmail)
    // const showCphEmailError = this.props.affiliateCode === "cpp" && isCphEmail
    // console.log(showCphEmailError)

    return (
      <div className="form--parking__essentials">
        <header className={"form__header"}>
          <h4>{textKeys.info || "Dine oplysninger"}</h4>
          {this.renderAdvantageLogin()}
        </header>

        <div className={"form__section form__section--short form__section--light"}>
          <div className={"form__section__inner"}>
            <div
              className={`form__field form__field--text is-required ${
                billingAddress.firstName && billingAddress.firstName?.length > 0 ? "is-filled" : ""
              } ${(checkoutErrors.firstName && checkoutErrors.showErrors) || billingAddress.firstName?.length > 50 ? "is-invalid" : ""} is-bound`}
            >
              <span className="form__valid" />
              <input
                className="form__item "
                tabIndex="1"
                type="text"
                name="firstName"
                autoComplete="given-name"
                value={billingAddress.firstName}
                onChange={(event) => this.handleInputChange(event, 50)}
              />
              <label htmlFor="firstName" className="form__label">
                <span className="form__label__text">
                  {textKeys.firstname || "Fornavn"}&nbsp;&nbsp;<strong>&nbsp;</strong>
                </span>
              </label>
              {checkoutErrors.firstName && checkoutErrors.showErrors ? (
                <span className="form__notice">{textKeys.required || "Du skal udfylde dette felt"}</span>
              ) : null}
              {billingAddress.firstName?.length > 50 ? (
                <span className="form__notice">
                  {this.props.validationMessageReplace(billingAddress.firstName, validationTextKeys.firstnameMessage) || "Dit input er for langt."}
                </span>
              ) : null}
            </div>
          </div>
          <div className={"form__section__inner"}>
            <div
              className={`form__field form__field--text is-required ${
                billingAddress.firstName && billingAddress.lastName?.length > 0 ? "is-filled" : ""
              } ${(checkoutErrors.lastName && checkoutErrors.showErrors) || billingAddress.lastName?.length > 50 ? "is-invalid" : ""} is-bound`}
            >
              <span className="form__valid" />
              <input
                className="form__item "
                tabIndex="2"
                type="text"
                name="lastName"
                autoComplete="family-name"
                value={billingAddress.lastName}
                onChange={(event) => this.handleInputChange(event, 50)}
              />
              <label htmlFor="lastName" className="form__label">
                <span className="form__label__text">
                  {textKeys.lastname || "Efternavn"}&nbsp;&nbsp;<strong>&nbsp;</strong>
                </span>
              </label>
              {checkoutErrors.lastName && checkoutErrors.showErrors ? (
                <span className="form__notice">{textKeys.required || "Du skal udfylde dette felt"}</span>
              ) : null}
              {billingAddress.lastName?.length > 50 ? (
                <span className="form__notice">
                  {this.props.validationMessageReplace(billingAddress.lastName, validationTextKeys.lastnameMessage) || "Dit input er for langt."}
                </span>
              ) : null}
            </div>
          </div>
        </div>
        <div className={"form__section form__section--short form__section--light"}>
          {hideFields?.hidePostcode && hideFields?.hideCity ? (
            ""
          ) : (
            <div className={`form__section__inner ${hideFields?.hidePostcode || hideFields?.hideCity ? "" : "d-flex--sm"}`}>
              {!hideFields?.hidePostcode ? (
                <div
                  className={`form__field form__field--text is-required ${
                    billingAddress.postcode && billingAddress.postcode?.length > 0 ? "is-filled" : ""
                  } ${(checkoutErrors.postcode && checkoutErrors.showErrors) || billingAddress.postcode?.length > 10 ? "is-invalid" : ""} is-bound`}
                >
                  <span className="form__valid" />
                  <input
                    className="form__item "
                    tabIndex="3"
                    type="text"
                    name="postcode"
                    autoComplete="postal-code"
                    value={billingAddress.postcode}
                    onChange={(event) => this.handleInputChange(event, 10, hideFields?.hideCity)}
                  />
                  <label htmlFor="postcode" className="form__label">
                    <span className="form__label__text">
                      {textKeys.postcode || "Postnr."}&nbsp;&nbsp;<strong>&nbsp;</strong>
                    </span>
                  </label>
                  {checkoutErrors.postcode && checkoutErrors.showErrors ? (
                    <span className="form__notice">{textKeys.required || "Du skal udfylde dette felt"}</span>
                  ) : null}
                  {billingAddress.postcode?.length > 10 ? (
                    <span className="form__notice">
                      {this.props.validationMessageReplace(billingAddress.postcode, validationTextKeys.postcodeMessage) || "Dit input er for langt."}
                    </span>
                  ) : null}
                </div>
              ) : (
                ""
              )}
              {!hideFields?.hideCity ? (
                <div
                  className={`form__field form__field--text is-required ${
                    billingAddress.town && billingAddress.town?.length > 0 ? "is-filled" : ""
                  } ${(checkoutErrors.town && checkoutErrors.showErrors) || billingAddress.town?.length > 50 ? "is-invalid" : ""} is-bound`}
                >
                  <span className="form__valid" />
                  <input
                    className="form__item "
                    id="town"
                    tabIndex="4"
                    type="text"
                    name="town"
                    autoComplete="address-level2"
                    value={billingAddress.town}
                    onChange={(event) => this.handleInputChange(event, 50)}
                  />
                  <label htmlFor="town" className="form__label">
                    <span className="form__label__text">
                      {textKeys.city || "By"}&nbsp;&nbsp;<strong>&nbsp;</strong>
                    </span>
                  </label>
                  {checkoutErrors.town && checkoutErrors.showErrors ? (
                    <span className="form__notice">{textKeys.required || "Du skal udfylde dette felt"}</span>
                  ) : null}
                  {billingAddress.town?.length > 50 ? (
                    <span className="form__notice">
                      {this.props.validationMessageReplace(billingAddress.town, validationTextKeys.cityMessage) || "Dit input er for langt."}
                    </span>
                  ) : null}
                </div>
              ) : (
                ""
              )}
            </div>
          )}
          <div
            className={`form__section__inner ${(!hideFields?.hidePostcode || !hideFields?.hideCity) && hideFields?.hideCountry ? "d-flex--sm" : ""}`}
          >
            <div
              className={`form__field form__field--text is-required ${emailHasContent ? "is-filled" : ""} ${
                isEmailError || billingAddress.email?.length > 100 || checkoutErrors.appleRelayEmail ? "is-invalid" : ""
              } is-bound`}
            >
              <span className="form__valid" />
              <input
                className="form__item "
                tabIndex="5"
                type="email"
                name="email"
                autoComplete="email"
                value={billingAddress.email}
                onChange={(event) => this.handleInputChange(event, 100)}
              />
              <label htmlFor="email" className="form__label">
                <span className="form__label__text">
                  {textKeys.email || "Email"}&nbsp;&nbsp;<strong>&nbsp;</strong>
                </span>
              </label>
              {!checkoutErrors.specialCharsEmail && checkoutErrors.email && checkoutErrors.showErrors ? (
                <span className="form__notice">{textKeys.required || "Du skal udfylde dette felt"}</span>
              ) : null}
              {billingAddress.email?.length > 100 ? (
                <span className="form__notice">
                  {this.props.validationMessageReplace(billingAddress.email, validationTextKeys.emailMessage) || "Dit input er for langt."}
                </span>
              ) : null}

              {isEmailAppleRelay ? (
                <span className="form__notice">
                  {this.props.validationMessageReplace(billingAddress.email, validationTextKeys.emailAppleMessage) ||
                    "For at sikre, at du modtager din ordrebekræftelse, beder vi dig indtaste en anden gyldig e-mailadresse. Der kan desværre ikke sendes post til Apples “Private relay“ adresser"}
                </span>
              ) : null}
              {checkoutErrors.cphEmail && checkoutErrors.showErrors ? (
                <span className="form__notice">
                  {this.props.validationMessageReplace(billingAddress.email, validationTextKeys.emailCphMessage) ||
                    "For at du må bruge en CPH affiliate kode, skal du have en gyldig CPH e-mailadresse."}
                </span>
              ) : null}
              {checkoutErrors.specialCharsEmail && checkoutErrors.showErrors ? (
                <span className="form__notice">
                  {validationTextKeys.emailSpecialCharactersMessage || "Emailaddresse må ikke indeholde æ, ø og å"}
                </span>
              ) : null}
            </div>
            {(!hideFields?.hidePostcode || !hideFields?.hideCity) && hideFields?.hideCountry ? (
              <div
                className={`form__field form__field--text is-required 
                        ${billingAddress.mobilePhone && billingAddress.mobilePhone?.length > 0 ? "is-filled" : ""} 
                        ${
                          ((checkoutErrors.mobilePhone || checkoutErrors.mobilePhoneFormat) && checkoutErrors.showErrors) ||
                          billingAddress.mobilePhone?.length > 20
                            ? "is-invalid"
                            : ""
                        } is-bound`}
              >
                <span className="form__valid" />
                <input
                  className="form__item "
                  tabIndex="6"
                  type="tel"
                  name="mobilePhone"
                  autoComplete="tel"
                  value={billingAddress.mobilePhone}
                  onChange={(event) => this.handlePhoneRegex(event)}
                />

                <label htmlFor="mobilePhone" className="form__label">
                  <span className="form__label__text">
                    {textKeys.mobilenumber || "Mobilnr."}&nbsp;&nbsp;<strong>&nbsp;</strong>
                  </span>
                </label>
                {checkoutErrors.mobilePhone && checkoutErrors.showErrors ? (
                  <span className="form__notice">{textKeys.required || "Du skal udfylde dette felt"}</span>
                ) : null}
                {billingAddress.mobilePhone?.length > 20 ? (
                  <span className="form__notice">
                    {this.props.validationMessageReplace(billingAddress.mobilePhone, validationTextKeys.mobilenumberMessage) ||
                      "Dit input er for langt."}
                  </span>
                ) : null}
                {checkoutErrors.mobilePhoneFormat && checkoutErrors.showErrors ? (
                  <span className="form__notice">{textKeys.mobilePhoneFormatRequired || "Mobilnr. skal starte med landekode f.eks. +45"}</span>
                ) : null}
              </div>
            ) : (
              ""
            )}
          </div>
          {hideFields?.hidePostcode && hideFields?.hideCity ? (
            <div
              className={`form__section__inner ${hideFields?.hidePostcode && hideFields?.hideCity && !hideFields?.hideCountry ? "d-flex--sm" : ""}`}
            >
              <div
                className={`form__field form__field--text is-required 
                        ${billingAddress.mobilePhone && billingAddress.mobilePhone?.length > 0 ? "is-filled" : ""} 
                        ${
                          ((checkoutErrors.mobilePhone || checkoutErrors.mobilePhoneFormat) && checkoutErrors.showErrors) ||
                          billingAddress.mobilePhone?.length > 20
                            ? "is-invalid"
                            : ""
                        } is-bound`}
              >
                <span className="form__valid" />
                <input
                  className="form__item "
                  tabIndex="6"
                  type="tel"
                  name="mobilePhone"
                  autoComplete="tel"
                  value={billingAddress.mobilePhone}
                  onChange={(event) => this.handlePhoneRegex(event)}
                />

                <label htmlFor="mobilePhone" className="form__label">
                  <span className="form__label__text">
                    {textKeys.mobilenumber || "Mobilnr."}&nbsp;&nbsp;<strong>&nbsp;</strong>
                  </span>
                </label>
                {checkoutErrors.mobilePhone && checkoutErrors.showErrors ? (
                  <span className="form__notice">{textKeys.required || "Du skal udfylde dette felt"}</span>
                ) : null}
                {billingAddress.mobilePhone?.length > 20 ? (
                  <span className="form__notice">
                    {this.props.validationMessageReplace(billingAddress.mobilePhone, validationTextKeys.mobilenumberMessage) ||
                      "Dit input er for langt."}
                  </span>
                ) : null}
                {checkoutErrors.mobilePhoneFormat && checkoutErrors.showErrors ? (
                  <span className="form__notice">{textKeys.mobilePhoneFormatRequired || "Mobilnr. skal starte med landekode f.eks. +45"}</span>
                ) : null}
              </div>
              {!hideFields?.hideCountry ? (
                <div className="form__field form__field--select is-filled is-bound">
                  <div className="form__container">
                    <span className="form__valid" />
                    <select
                      id="select"
                      className="form__item "
                      name="countryId"
                      autoComplete="personal_details[CountryId]"
                      aria-label="Select menu"
                      tabIndex="7"
                      value={billingAddress.countryId}
                      onChange={(event) => this.handleCountryChange(event)}
                    >
                      {countryHelper.countryCodes.map((option, index) => {
                        return (
                          <option value={option.value} key={"countryId" + index}>
                            {option.label}
                          </option>
                        )
                      })}
                    </select>
                    <label htmlFor="select" className="form__label">
                      <span className="form__label__text">
                        {textKeys.country || "Land"}&nbsp;&nbsp;<strong>&nbsp;</strong>
                      </span>
                    </label>
                  </div>
                </div>
              ) : (
                ""
              )}
            </div>
          ) : (
            ""
          )}
        </div>
        <div className={"form__section form__section--short form__section--light"}>
          {((!hideFields?.hidePostcode || !hideFields?.hideCity) && hideFields?.hideCountry) || (hideFields?.hidePostcode && hideFields?.hideCity) ? (
            ""
          ) : (
            <div className={"form__section__inner"}>
              <div
                className={`form__field form__field--text is-required 
                        ${billingAddress.mobilePhone && billingAddress.mobilePhone?.length > 0 ? "is-filled" : ""} 
                        ${
                          ((checkoutErrors.mobilePhone || checkoutErrors.mobilePhoneFormat) && checkoutErrors.showErrors) ||
                          billingAddress.mobilePhone?.length > 20
                            ? "is-invalid"
                            : ""
                        } is-bound`}
              >
                <span className="form__valid" />
                <input
                  className="form__item "
                  tabIndex="6"
                  type="tel"
                  name="mobilePhone"
                  autoComplete="tel"
                  value={billingAddress.mobilePhone}
                  onChange={(event) => this.handlePhoneRegex(event)}
                />

                <label htmlFor="mobilePhone" className="form__label">
                  <span className="form__label__text">
                    {textKeys.mobilenumber || "Mobilnr."}&nbsp;&nbsp;<strong>&nbsp;</strong>
                  </span>
                </label>
                {checkoutErrors.mobilePhone && checkoutErrors.showErrors ? (
                  <span className="form__notice">{textKeys.required || "Du skal udfylde dette felt"}</span>
                ) : null}
                {billingAddress.mobilePhone?.length > 20 ? (
                  <span className="form__notice">
                    {this.props.validationMessageReplace(billingAddress.mobilePhone, validationTextKeys.mobilenumberMessage) ||
                      "Dit input er for langt."}
                  </span>
                ) : null}
                {checkoutErrors.mobilePhoneFormat && checkoutErrors.showErrors ? (
                  <span className="form__notice">{textKeys.mobilePhoneFormatRequired || "Mobilnr. skal starte med landekode f.eks. +45"}</span>
                ) : null}
              </div>
            </div>
          )}

          {(hideFields?.hidePostcode && hideFields?.hideCity && !hideFields?.hideCountry) ||
          (hideFields?.hidePostcode && hideFields?.hideCity && hideFields?.hideCountry) ||
          hideFields?.hideCountry ? (
            ""
          ) : (
            <div className={"form__section__inner"}>
              <div className="form__field form__field--select is-filled is-bound">
                <div className="form__container">
                  <span className="form__valid" />
                  <select
                    id="select"
                    className="form__item "
                    name="countryId"
                    autoComplete="personal_details[CountryId]"
                    aria-label="Select menu"
                    tabIndex="7"
                    value={billingAddress.countryId}
                    onChange={(event) => this.handleCountryChange(event)}
                  >
                    {countryHelper.countryCodes.map((option, index) => {
                      return (
                        <option value={option.value} key={"countryId" + index}>
                          {option.label}
                        </option>
                      )
                    })}
                  </select>
                  <label htmlFor="select" className="form__label">
                    <span className="form__label__text">
                      {textKeys.country || "Land"}&nbsp;&nbsp;<strong>&nbsp;</strong>
                    </span>
                  </label>
                </div>
              </div>
            </div>
          )}
        </div>

        {/* {moreThanOneBillingError && checkoutErrors.showErrors ?
                    <span className={'form__notice form__notice--box is-invalid'}>
                        {moreThanOneBillingError ? `${textKeys.multipleRequired || "Du skal udfylde disse felter"}: ` : ""}
                        {checkoutErrors.firstName ? `${textKeys.firstName || "Fornavn"} ` : ""}
                        {checkoutErrors.lastName ? `${textKeys.lastName || "Efternavn"} ` : ""}
                        {checkoutErrors.postcode ? `${textKeys.postcode || "Postnr."} ` : ""}
                        {checkoutErrors.town ? `${textKeys.city || "By"} ` : ""}
                        {checkoutErrors.email ? `${textKeys.email || "Email"} ` : ""}
                        {checkoutErrors.mobilePhone ? `${textKeys.mobilenumber || "Mobilnr."} ` : ""}
                    </span>
                    : ""} */}
      </div>
    )
  }
}
export default CheckoutBillingInformation
